import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';
import Icon from '@/components/Icon/IconAsset';

export const StyledLink = styled.a`
  ${tw`relative`}
  ${tw`flex flex-col`}
  ${tw`px-1 py-[4px]`}

  &:before {
    ${tw`absolute`}
    ${tw`content-['']`}
    ${tw`bg-ui-colours-ui1`}
    ${tw`w-full`}
    ${tw`h-full`}
    ${tw`-top-0 -left-0`}
    ${tw`rounded`}
    ${tw`opacity-0`}
    ${tw`transition-opacity duration-300 ease-out`}
  }

  &:hover:before {
    ${tw`opacity-100`}
  }
`;

export const StyledDescription = styled.span`
  ${tw`relative`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-s text-primary-p1`}
  ${tw`mt-[4px]`}
`;

export const StyledTitle = styled.span`
  ${tw`flex items-center flex-wrap gap-x-[6px] gap-y-[5px]`}
  ${tw`relative`}
  ${tw`font-semi-bold font-poppins`}
  ${tw`text-tag-l`}
  ${tw`text-primary-p1`}
`;

export const StyledImage = styled(ImageElement)`
  ${tw`w-[176px]`}
  ${tw`mb-1`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`inline`}
  ${tw`max-h-[18px]`}
  ${tw`max-w-[18px]`}
  ${tw`mr-1`}
`;
